'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _ScreenManager = require('./ScreenManager');

var _ScreenManager2 = _interopRequireDefault(_ScreenManager);

var _ScreenReducer = require('../../components/screen/ScreenReducer');

var _ScreenKeyConst = require('./ScreenKeyConst');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    screenId: (0, _ScreenReducer.getScreenId)(state.screen, _ScreenKeyConst.ACTIVE_SCREEN_KEY)
  };
};

var ScreenManagerContainer = (0, _reactRedux.connect)(mapStateToProps)(_ScreenManager2.default);

exports.default = ScreenManagerContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/ScreenManagerContainer.js
// module id = 344
// module chunks = 10